import { LoadingScreen } from "components/LoadingScreen";
import { Page } from "containers/Page";
import { useSearchParams } from "react-router-dom";
import { FiltrosDetalhesLicenciamento } from "./containers/Filtros";
import { ListagemDetalhesLicenciamento } from "./containers/ListagemDetalhesLicenciamento";
import { useSolicitacaoLicenciamentos } from "hooks/useSolicitacaoLicenciamentos";
import { useEffect, useState } from "react";
import { StatusEmissao, StatusEmissaoExibir } from "./enums/StatusEmissaoEnum";
import { ModalRenomear } from "./containers/ModalRenomear";
import { ModalConfirmacaoEmissao } from "./containers/ModalConfirmacaoEmissao";
import { ModalEmissaoManual } from "./containers/ModalEmissaoManual";
import { ModalConfirmacaoEmissaoManual } from "./containers/ModalConfirmacaoEmissaoManual";
import { IEmissaoManual } from "./interfaces/IEmissaoManual";
import { utils, writeFileXLSX } from "xlsx";
import { converterDataBr } from "_utils/Data";
import { IDetalhesEmissaoExportar } from "../Interfaces/IDetalhesEmissaoExportar";

export function DetalhesLicenciamento() {
  const {
    selectedRowsDetalhes,
    setSelectedRowsDetalhes,
    clearRowsDetalhes,
    setClearRowsDetalhes,
    listarDetalhesLicenciamento,
    listaDetalhesLicenciamentos,
    buscarDadosLicenciamento,
    dadosLote,
    reemitirCrlvs,
    erroReemitir,
    downloadCrlv,
    showModalConfirmarEmissaoManual,
    setShowModalConfirmarEmissaoManual,
    emissaoManual,
    anoSolicitado,
    exportarCrlv,
    dadosExportar,
    setLimit,
    setPage,
    limit,
    page,
    totalRows,
    filtrosDetalhes,
    mensagemErroReemitir,
    loading,
  } = useSolicitacaoLicenciamentos();

  function handleLimitChange(limit: number) {
    setLimit(limit);
  }

  function handlePageChange(page: number) {
    setPage(page);
  }

  const [disabledEmissaoManual, setDisabledEmissaoManual] =
    useState<boolean>(true);

  useEffect(() => {
    const qtdEmissoesManuaisPermitidas = 1;

    if (
      selectedRowsDetalhes.length !== qtdEmissoesManuaisPermitidas ||
      selectedRowsDetalhes.some(
        (linha) => linha.statusEmissao != StatusEmissao.Falha,
      )
    ) {
      setDisabledEmissaoManual(true);
      return;
    }
    setDisabledEmissaoManual(false);
  }, [selectedRowsDetalhes]);

  const [searchParams] = useSearchParams();
  const idLote = searchParams.get("idLote");

  useEffect(() => {
    if (idLote) {
      const identificador = Number(idLote);
      if (identificador) {
        listarDetalhesLicenciamento(identificador);
        buscarDadosLicenciamento(identificador);
        return;
      }
    }

    window.location.href = "/app/backoffice/licenciamento";
  }, [limit, page]);

  const [exibirModalEmissaoManual, setExibirModalEmissaoManual] =
    useState<boolean>(false);
  const [showModalConfirmacaoEmissao, setShowModalConfirmacaoEmissao] =
    useState<boolean>(false);

  const [loadingReemitir, setLoadingReemitir] = useState<boolean>(false);
  const [showModalRenomear, setShowModalRenomear] = useState<boolean>(false);
  const [padraoSelecionado, setPadraoSelecionado] = useState(null);

  const onClickEmissaoManual = () => {
    setExibirModalEmissaoManual(true);
  };

  async function onClickEmitir() {
    setLoadingReemitir(true);
    setShowModalConfirmacaoEmissao(true);

    await reemitirCrlvs(Number(idLote));

    setLoadingReemitir(false);
    await listarDetalhesLicenciamento(Number(idLote));
  }

  const [showModalDownload, setShowModalDownload] = useState<boolean>(false);
  const handleCloseModalDownload = () => {
    setShowModalDownload(false);
  };
  const onClickDownload = async () => {
    if (selectedRowsDetalhes.length) {
      setShowModalDownload(true);
      return;
    }
    setShowModalRenomear(true);
  };

  function handleCloseModalRenomear() {
    setShowModalRenomear(false);
    setPadraoSelecionado(null);
  }

  const onConfirmModalRenomear = () => {
    downloadCrlv(
      idLote!,
      selectedRowsDetalhes.map((linha) => linha.idItemLoteLicenciamentos),
      padraoSelecionado!,
    );
    handleCloseModalRenomear();
  };

  function handleCloseModalConfirmacaoEmissao() {
    setShowModalConfirmacaoEmissao(false);
  }

  const handleSubmitEmissaoManual = (dados: IEmissaoManual) => {
    setExibirModalEmissaoManual(false);

    if (idLote) {
      emissaoManual(
        selectedRowsDetalhes[0].idItemLoteLicenciamentos,
        dados,
        Number(idLote),
      );
      setClearRowsDetalhes(true);
    }
  };
  const handleCloseModalEmissaoManual = () => {
    setExibirModalEmissaoManual(false);
  };
  const handleCloseModalConfirmacaoEmissaoManual = () => {
    setShowModalConfirmarEmissaoManual(false);
  };

  const onConfirmModalDownload = async () => {
    setShowModalDownload(false);
    setShowModalRenomear(true);
  };

  const [showModalExportar, setShowModalExportar] = useState<boolean>(false);
  const handleCloseModalExportar = () => {
    setShowModalExportar(false);
  };

  const onClickExportar = async () => {
    if (selectedRowsDetalhes.length) {
      setShowModalExportar(true);
      return;
    }
    await exportarCrlv(Number(idLote));
  };
  const onConfirmModalExportar = async () => {
    await exportarCrlv(
      Number(idLote),
      selectedRowsDetalhes.map((item) => item.idItemLoteLicenciamentos),
    );
    setShowModalExportar(false);
  };

  useEffect(() => {
    if (dadosExportar.length > 0) {
      const dadosPlanilha = dadosExportar.map(
        (item: IDetalhesEmissaoExportar) => {
          const detalheEmissao: any = {
            Placa: item.placa ? item.placa.toUpperCase() : "--",
            Renavam: item.renavam,
            Chassi: item.chassi,
            UF: item.uf,
            Exercício: item.exercicioSolicitado,
            "Data de emissão": item.dataEmissao
              ? converterDataBr(new Date(item.dataEmissao))
              : "-",
            Observação:
              item.link && item.observacao !== "Emissão Manual"
                ? "CRLV emitido com sucesso"
                : (item.observacao ?? ""),
            "Status Emissão": item.statusEmissao
              ? StatusEmissaoExibir[item.statusEmissao]
              : "--",
            Tentativas: item.tentativas,
            Link: item.link ?? "",
          };

          return detalheEmissao;
        },
      );

      const cols = [
        { wch: 10 },
        { wch: 15 },
        { wch: 20 },
        { wch: 5 },
        { wch: 10 },
        { wch: 15 },
        { wch: 30 },
        { wch: 15 },
        { wch: 15 },
        { wch: 30 },
      ];

      const planilha = utils.json_to_sheet(dadosPlanilha);
      planilha["!cols"] = cols;
      const workBook = utils.book_new();
      utils.book_append_sheet(workBook, planilha, "CRLVs");
      writeFileXLSX(workBook, `CRLV_${idLote}.xlsx`);
    }
  }, [dadosExportar, idLote]);

  return (
    <Page title="Emitir licenciamentos">
      <LoadingScreen mostrar={loading} />
      <FiltrosDetalhesLicenciamento
        handleSubmitFiltros={listarDetalhesLicenciamento}
        idLote={dadosLote.id}
      />
      <ListagemDetalhesLicenciamento
        clearRows={clearRowsDetalhes}
        setRowsSelected={setSelectedRowsDetalhes}
        selectedRows={selectedRowsDetalhes}
        lista={listaDetalhesLicenciamentos}
        dadosLote={dadosLote}
        onClickEmissaoManual={onClickEmissaoManual}
        disabledEmissaoManual={disabledEmissaoManual}
        onClickReemitir={onClickEmitir}
        disabledReemitir={!!selectedRowsDetalhes.length}
        onClickDownload={onClickDownload}
        showModalDownload={showModalDownload}
        onConfirmModalDownload={onConfirmModalDownload}
        handleCloseModalDownload={handleCloseModalDownload}
        showModalExportar={showModalExportar}
        onConfirmModalExportar={onConfirmModalExportar}
        handleCloseModalExportar={handleCloseModalExportar}
        onClickExportar={onClickExportar}
        onChangePage={handlePageChange}
        onChangeRowsPerPage={handleLimitChange}
        rowsPerPage={limit}
        totalRows={totalRows}
      />
      <ModalRenomear
        handleClose={handleCloseModalRenomear}
        show={showModalRenomear}
        onConfirm={onConfirmModalRenomear}
        padraoSelecionado={padraoSelecionado}
        setPadraoSelecionado={setPadraoSelecionado}
      />
      <ModalConfirmacaoEmissao
        handleClose={handleCloseModalConfirmacaoEmissao}
        show={showModalConfirmacaoEmissao}
        loading={loadingReemitir}
        erro={erroReemitir}
        mensagemErro={mensagemErroReemitir}
      />
      <ModalEmissaoManual
        handleClose={handleCloseModalEmissaoManual}
        handleSubmit={handleSubmitEmissaoManual}
        showModal={exibirModalEmissaoManual}
        ano={anoSolicitado}
      ></ModalEmissaoManual>
      <ModalConfirmacaoEmissaoManual
        show={showModalConfirmarEmissaoManual}
        handleClose={handleCloseModalConfirmacaoEmissaoManual}
      ></ModalConfirmacaoEmissaoManual>
    </Page>
  );
}
